import React, { useEffect, useReducer, useState } from "react";
import { Modal } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import FiliskaPagination from "../components/FiliskaPagination";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import useAxios from "../hooks/useAxios";
import CartScreenTouch from "../screens/CartScreenTouch";
import { getError, turkishCurrencyFormatterNoPrecision } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true, error: "" };
    case "FETCH_SUCCESS":
      return {
        ...state,
        error: "",
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "FETCHCART_REQUEST":
      return { ...state, loadingFetchCart: true, errorFetchCart: "" };
    case "FETCHCART_SUCCESS":
      return {
        ...state,
        errorFetchCart: "",
        loadingFetchCart: false,
      };
    case "FETCHCART_FAIL":
      return {
        ...state,
        loadingFetchCart: false,
        errorFetchCart: action.payload,
      };
    default:
      return state;
  }
};

export default function OrdersTableList({ startLineNum, endLineNum }) {
  const [page, setPage] = useState(1);
  const [selectedOrder, setSelectedOrder] = useState({
    totalPrice: 0,
    cachePayment: 0,
    posPayment: 0,
    totalSpendingCache: 0,
    totalSpendingPOS: 0,
  });
  const [showAnalyticReport, setShowAnalyticReport] = useState(false);
  const [pages, setPages] = useState();
  const [orders, setOrders] = useState([]);
  const [cart, setCart] = useState({ tableNum: 0 });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [showCartScreenTouchModal, setShowCartScreenTouchModal] =
    useState(false);

  const [{ loadingFetchCart, errorFetchCart, loading, error }, dispatch] =
    useReducer(reducer, {
      loadingFetchCart: false,
      errorFetchCart: "",
      loading: false,
      error: "",
    });
  const axios = useAxios();

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch({ type: "FETCH_REQUEST" });
        const { data } = await axios.get(
          `/api/analytics?page=${page}&type=line&startLineNum=${startLineNum}&endLineNum=${endLineNum}`
        );

        setOrders(data.orders);
        setPages(data.pages);

        dispatch({ type: "FETCH_SUCCESS" });
      } catch (err) {
        dispatch({
          type: "FETCH_FAIL",
          payload: getError(err),
        });
      }
    };

    fetchData();
  }, [startLineNum, endLineNum, page]);

  const fetchCartHandler = async (lineNum) => {
    try {
      dispatch({ type: "FETCHCART_REQUEST" });
      const { data } = await axios.get(
        `/api/orders/lineNum/${lineNum ? lineNum : "0"}`
      );

      dispatch({ type: "FETCHCART_SUCCESS" });

      setCart(data);
    } catch (error) {
      dispatch({ type: "FETCHCART_FAIL" });
    }
  };

  return loading ? (
    <LoadingBox />
  ) : (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>TARIH</th>
            <th>{"SİPARİŞ SIRA NO"}</th>
            {!isTabletOrMobile && <th>{"İSİM"}</th>}
            <th>TOPLAM</th>
            {!isTabletOrMobile && <th>NAKIT/POS</th>}
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order._id || order.lineNum}>
              <td>
                {new Date(order.createdAt)
                  .toLocaleString("tr-TR")
                  .substring(0, 16)}
              </td>
              <td>
                {
                  <div
                    className=" linenNumOrderList"
                    onClick={() => {
                      setShowCartScreenTouchModal(true);
                      fetchCartHandler(order.lineNum);
                    }}
                  >
                    <span className="text-primary">{order.lineNum}</span>
                    <span>
                      {order.description && isTabletOrMobile
                        ? " " + order.description
                        : ""}
                    </span>
                  </div>
                }
              </td>
              {!isTabletOrMobile && (
                <td>
                  {
                    <div className="linenNumOrderList">
                      {order.description && !isTabletOrMobile
                        ? " " + order.description
                        : ""}
                    </div>
                  }
                </td>
              )}
              <td>
                {
                  <div
                    onClick={() => {
                      setShowAnalyticReport(true);
                      setSelectedOrder(order);
                    }}
                  >
                    {turkishCurrencyFormatterNoPrecision(order.totalPrice)}
                  </div>
                }

                <span className="text-danger">
                  {order.isStaffMeal ? "Personel!" : ""}
                </span>
              </td>
              {!isTabletOrMobile && (
                <td>
                  {order.cachePayment + order.posPayment > 0 && (
                    <>
                      <div>
                        {order.cachePayment
                          ? turkishCurrencyFormatterNoPrecision(
                              order.cachePayment
                            ) + " Nakit"
                          : ""}
                      </div>
                      <div>
                        {order.posPayment
                          ? turkishCurrencyFormatterNoPrecision(
                              order.posPayment
                            ) + " POS"
                          : ""}
                      </div>
                    </>
                  )}
                </td>
              )}
            </tr>
          ))}
          {loading && (
            <tr>
              <td colSpan={10}>
                <LoadingBox></LoadingBox>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div>
        <FiliskaPagination
          leftRightSize={2}
          page={page}
          pages={pages}
          onFirst={() => {
            setPage(1);
          }}
          onLast={() => {
            setPage(pages);
          }}
          onNext={() => {
            if (page < pages) {
              setPage(page + 1);
            }
          }}
          onPrev={() => {
            if (page > 1) {
              setPage(page - 1);
            }
          }}
          onItemNext={(p) => {
            setPage(p);
          }}
          onItemPrev={(p) => {
            setPage(p);
          }}
        ></FiliskaPagination>
      </div>

      {showCartScreenTouchModal && (
        <Modal
          show={showCartScreenTouchModal}
          onHide={() => setShowCartScreenTouchModal(false)}
        >
          <Modal.Body>
            {loadingFetchCart ? (
              <LoadingBox />
            ) : errorFetchCart ? (
              <MessageBox>{getError(errorFetchCart)}</MessageBox>
            ) : (
              <CartScreenTouch
                tableTemp={cart.tableNum}
                isCustomerOrder={false}
                height="100%"
                readOnlyCart={cart}
                historic={true}
                ozetle={true}
              ></CartScreenTouch>
            )}
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}
